import { useEffect } from 'react';
import Loading from '../components/Loading';
import ServerError from '../components/ServerError';
import useTrainer from '../hooks/useTrainer';
import useAuth from '../hooks/useAuth';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Divider, Drawer, Link } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Logo from './Logo';

const NotLoggedInButtons = ({ loginLink, signupLink }) => {
  return (
    <>
      <Link component={RouterLink} to={loginLink} variant="body1">
        <Button color="primary" variant="outlined">
          Login
        </Button>
      </Link>
      <Divider
        orientation="horizontal"
        sx={{
          height: 32,
          mx: 2,
        }}
      />

      <Link
        color="textSecondary"
        component={RouterLink}
        to={signupLink}
        variant="body1"
      >
        <Button color="primary" variant="contained">
          Signup
        </Button>
      </Link>
    </>
  );
};

const Account = ({ accountLink }) => {
  return (
    <>
      <Link color="textSecondary" component={RouterLink} to={accountLink}>
        <Button color="primary" variant="outlined">
          Account
        </Button>
      </Link>
      <Divider
        orientation="horizontal"
        variant="fullWidth"
        sx={{
          height: 32,
          mx: 2,
        }}
      />

      <Link color="textSecondary" component={RouterLink} to="/logout">
        <Button color="primary" variant="outlined">
          Logout
        </Button>
      </Link>
    </>
  );
};
const MainSidebar = ({ onMobileClose, openMobile }) => {
  const { data: trainerData, loading: trainerLoading, error } = useTrainer();
  const location = useLocation();
  const auth = useAuth();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  if (trainerLoading) {
    return <Loading />;
  }

  if (error) {
    console.error(error);
    return <ServerError message={error.message} />;
  }

  if (!trainerData) {
    return <Loading />;
  }

  if (auth.loading) {
    return <></>;
  }

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={!lgUp && openMobile}
      variant="temporary"
      PaperProps={{
        sx: {
          backgroundColor: 'background.default',
          width: 256,
        },
      }}
    >
      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          p: 2,
        }}
      >
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Box
          sx={{
            pb: 2,
            pt: 3,
          }}
        >
          {auth.user && (
            <Account accountLink={`/${trainerData?.webPage?.slug}/account`} />
          )}
          {!auth.user && (
            <NotLoggedInButtons
              loginLink={`/${trainerData?.webPage?.slug}/login`}
              signupLink={`/${trainerData?.webPage?.slug}/signup`}
            />
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

MainSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default MainSidebar;
